<template>
    <div v-if="viewData.isInitializationDone">
        <div class="row" v-if="viewData.currentPage === viewData.pages.KBA_FORM">
            <div class="column">
                <KBAForm ref="KBAForm" @change="onKBAFormChange"/>
            </div>
            <div class="column">
                <button v-if="formData === null" class="button warning expand" @click.stop="validateForm">Eingabe prüfen</button>
                <button :disabled="viewData.isLoading" v-else class="button success expand" @click.stop="sendForm">Abschicken</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.SUCCESS_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="ratisColoredText">
                        Formular erfolgreich abgeschickt
                    </h4>
                    <p>
                        Wir bedanken uns für Ihr entgegengebrachtes Vertrauen und melden uns bei Ihnen, sobald eine Rückmeldung des Kraftfahrtbundesamtes vorliegt.
                    </p>
                    <p>
                        Sie erhalten außerdem eine Kopie der versandten E-Mail an die von Ihnen angegebene E-Mail-Adresse.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.ERROR_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Es ist ein Fehler aufgetreten
                    </h4>
                    <p>
                        Wir bitten Sie um Entschuldigung.
                        Leider ist beim Versand des Formulars ein Fehler aufgetreten.
                        Bitte versuchen Sie es erneut.
                        Sollten Sie auch nach einem neuerlichen Versuch immer noch Probleme haben, wenden Sie sich bitte an
                        <a href="mailto:info@ratis.de">info@ratis.de</a>.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Erneut versuchen</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.APP_DOWN">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Anwendung nicht verfügbar
                    </h4>
                    <p>
                        Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import KBAForm from "@/components/KBAForm";
    import GENERAL from "@/constants/general";
    import Maintenance from '../api/maintenance';
    import Kba from '../api/kba';

    export default {
        name: "FormView",
        components: {KBAForm},
        data: () => ({
            viewData: {
                isLoading:      false,
                showAxiosError: false,
                currentPage: 0,
                pages: {
                    KBA_FORM:       0,
                    SUCCESS_PAGE:   1,
                    ERROR_PAGE:     2,
                    APP_DOWN:       3
                },
                isInitializationDone: false
            },
            formData: null
        }),
        methods: {
            async sendForm()
            {
                let me                          = this;
                this.viewData.isLoading         = true;
                this.viewData.showAxiosError    = false;

                try
                {
                    await Kba.sendKbaRequest(this.formData);
                    this.viewData.currentPage = this.viewData.pages.SUCCESS_PAGE;
                    this.createTrackingIframe();
                }
                catch (error)
                {
                    this.viewData.currentPage = me.viewData.pages.ERROR_PAGE;
                }
                finally
                {
                    this.viewData.isLoading = false;
                }
            },
            validateForm()
            {
                this.$refs.KBAForm.validateForm();
            },
            onKBAFormChange(formData)
            {
                this.formData = formData;
            },
            async resetForm()
            {
                await this.checkHealth();

                if (this.viewData.currentPage !== this.viewData.pages.APP_DOWN)
                {
                    this.viewData.currentPage = this.viewData.pages.KBA_FORM;
                }
            },
            createTrackingIframe()
            {
                let iframe = document.createElement('iframe');
                iframe.setAttribute('id', 'trackingIframe');
                iframe.setAttribute('src', GENERAL.TRACKING_URL);
                iframe.style.display = "none";
                document.body.appendChild(iframe);
                let me = this;
                iframe.onload = () => me.removeTrackingIframe();
            },
            removeTrackingIframe()
            {
                let iframe = document.getElementById('trackingIframe');
                document.body.removeChild(iframe);
            },
            async checkHealth()
            {
                try
                {
                    let response = await Maintenance.checkHealth();

                    if (response.is_down)
                        this.viewData.currentPage = this.viewData.pages.APP_DOWN;
                }
                catch (error)
                {
                    this.viewData.currentPage = this.viewData.pages.APP_DOWN;
                }
            }
        },
        async mounted()
        {
            await this.checkHealth();
            this.viewData.isInitializationDone = true;
        }
    }
</script>

<style scoped>
    .ratisColoredText{
        color:#e10065;
    }
    .redColoredText{
        color: red;
    }
</style>